<template>
   <a class="ui label" v-bind:class="colorClass">Cena: <span v-if="hasSale(item)" class="old-price-text">{{realOldPrice(item)}} &euro;</span>
   <span>{{realPrice(item)}} &euro;</span>
   </a>
</template>

<script>

export default {
    props: ['item', 'oneline'],
    data() {
      return {
      }
    },
    computed: {
        goods() {
        //loaded from parent
        return this.$store.state.goodStore.topgoods
        },
        cart() {
        return this.$store.state.cartStore.activeCart
        },
        cartItems() {
            return this.$store.state.cartStore.items
        },
        colorClass() {
            if (this.item.bail > 0 && this.hasSale(this.item) && !this.oneline) {
                return 'bright-yellow sale-badge';
            }

            return this.hasSale(this.item) ? 'bright-yellow' : 'red';
        },
        price_old_vat() {
            return this.item.base_price_old_vat;
        }
    },
    created() {
    },
    methods: {
        checkIfInCart(item){
            if(this.$store.state.cartStore.items.length > 0 && this.$store.state.cartStore.items.filter(function(e) { return e.good_id == item.id }).length > 0) return true;
            else return false;
        },
        hasSale(item) {
            return parseFloat(item.base_price_old_vat) > parseFloat(item.base_price_vat);
        },
        realPrice(item) {
			if (this.checkIfInCart(item)) {
                var cartItem = this.$store.state.cartStore.items.filter(function(e) { return e.good_id == item.id });
                return cartItem[0].price_vat;
            } else {
			    if (this.$store.state.categoryStore.selectedCategory.categoryLink == 'vairuma') {
				    return item.best_price_vat;
				} else {
                    return item.base_price_vat;
				}
			}
        },
        realOldPrice(item) {
           return this.price_old_vat;
        }
    }
}

</script>
<style>
.bright-yellow {
    background-color: #FFCC00 !important;
    color: #212121 !important;
    min-height: 28px !important;
}

.old-price-text {
    text-decoration: line-through;
    font-weight: normal !important;
}

.sale-badge {
    margin-bottom:6px !important;
}

@media (min-width: 1200px) {
    .sale-badge {
        margin-bottom:-5px !important;
    }
}
</style>



// WEBPACK FOOTER //
// Price.vue?a96baf76